import { ProjectConsumer } from './providers/ProjectProvider';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { LANGS } from './utils/constants';
import Tooltip from '@material-ui/core/Tooltip';

class LanguageAvatar extends React.Component {

    render() {

        const { lang, classes, inverted } = this.props;
        const isLongLang = lang.length > 2;
        const isVeryLongLang = lang.length > 6;
        const style = isVeryLongLang ?
            { width: '60px', borderRadius: '16px' }
            :
            isLongLang ?
                { width: '40px', borderRadius: '16px' }
                :
                {};

        return (
            <ProjectConsumer>
                {({ defaultLang }) => (
                    <Tooltip title={LANGS[lang] ?
                        (
                            LANGS[lang][defaultLang] ?
                                LANGS[lang][defaultLang]
                                :
                                LANGS[lang]["en"]
                        )
                        :
                        "Language unknown (" + lang + ")"}>
                        <Avatar
                            data-test="avatar-language"
                            className={inverted ?
                                classes.invertedFieldAvatar
                                :
                                classes.fieldAvatar}
                            style={style}>
                            {lang === "und" ? "None" : lang}
                        </Avatar>
                    </Tooltip>
                )}
            </ProjectConsumer>

        );
    }
}

LanguageAvatar.defaultPropes = {
    inverted: false
};

LanguageAvatar.propTypes = {
    inverted: PropTypes.bool,
    classes: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired
};

export default withStyles(styles)(LanguageAvatar);